// * Bootstrap libraries
import './_bootstrap';

// * Any other global site-wide JavaScript should be placed below.

(function($) {

    $(document).ready(function() {

        $('.field--name-field-paragraph-block .field--name-field-gallery-page').photobox('a',{ time:0 });
        $('.node.gallery .field--name-field-gallery').photobox('a',{ time:0 });
        $('.taxonomy-doma_kultury .field--name-field-dk-photos').photobox('a',{ time:0 });
        $('.node--type-news-events .field--name-field-news-gallery').photobox('a',{ time:0 });

        $('.fancy-form').fancybox();

        // карусель slider на главной
        $('.block--slider .field--name-field-slider-paragraph').slick({
            dots: true,
            infinite: true,
            speed: 500,
            autoplay: 1,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"></button>',
            nextArrow: '<button class="slick-next" aria-label="Next" type="button"></button>',
        });

        const container = document.querySelector(".warning");
        if (document.cookie.indexOf("warning") != -1) {
            container.classList.remove("warning--active");
        }
        if (document.querySelector(".warning")) {
            const apply = container.querySelector(".warning__apply");
            apply.addEventListener("click", () => {
                container.classList.remove("warning--active");
                document.cookie = "warning=true; max-age=2592000; path=/";
            });
        };

        $('.navmobile_button .btn_open, .nav_mobile_button .btn_close').click(function() {
            $(this).toggleClass('active_btn');
            $('#nav_mobile').toggleClass('show_menu');
            $('body').toggleClass('mobile_menu_overflow');
        });

        $('.nav_mobile_bg').click(function(){
            $('#nav_mobile').removeClass('show_menu');
            $('.btn_open').toggleClass('active_btn');
            $('.btn_close').toggleClass('active_btn');
            $('body').toggleClass('mobile_menu_overflow');
        });

    });
})(jQuery);